import type { ClickableItem, IsDropdownItem, VisibleItem } from 'layouts/main/sp-header/navigation/models';
import { NavigationItem } from 'layouts/main/sp-header/navigation/NavigationItem';
import { connect } from 'react-redux';
import {
  isAddonManagementVisible,
  isPostTradeVisible,
  isPriceImprovementBlotterVisible,
  isScheduledQuotesBlotterVisible,
  isSecondaryPostEventVisible,
} from 'state/selectors/common/router';
import type { AppState } from 'state/state.model';
export function PostTradeItem({ isVisible, isDropdownItem, onClick }: VisibleItem & IsDropdownItem & ClickableItem) {
  return (
    <NavigationItem
      isVisible={isVisible}
      targetRoute="/post-trade"
      label="appHeader.navigation.activities.postTrade"
      isDropdownItem={isDropdownItem}
      dataE2eSuffix="postTrade"
      onClick={onClick}
      title="appHeader.navigation.activities.postTrade.ariaLabel"
    />
  );
}

export const ConnectedPostTradeItem = connect((state: AppState) => ({
  isVisible: isPostTradeVisible(state),
}))(PostTradeItem);

export function AddonManagementItem({
  isVisible,
  isDropdownItem,
  onClick,
}: VisibleItem & IsDropdownItem & ClickableItem) {
  return (
    <NavigationItem
      isVisible={isVisible}
      targetRoute="/addon-management"
      label="appHeader.navigation.activities.addonManagement"
      dataE2eSuffix="addonManagement"
      isDropdownItem={isDropdownItem}
      onClick={onClick}
    />
  );
}

export const ConnectedAddonManagementItem = connect((state: AppState) => ({
  isVisible: isAddonManagementVisible(state),
}))(AddonManagementItem);

export function ScheduledQuotesBlotterItem({
  isVisible,
  isDropdownItem,
  onClick,
}: VisibleItem & IsDropdownItem & ClickableItem) {
  return (
    <NavigationItem
      isVisible={isVisible}
      targetRoute="/scheduled-quotes-blotter"
      category="Workspace"
      action="Scheduled quotes blotter"
      label="appHeader.navigation.activities.scheduledQuotes"
      dataE2eSuffix="scheduled-quotes"
      isDropdownItem={isDropdownItem}
      onClick={onClick}
    />
  );
}

export const ConnectedScheduledQuotesBlotterItem = connect((state: AppState) => ({
  isVisible: isScheduledQuotesBlotterVisible(state),
}))(ScheduledQuotesBlotterItem);

export function PriceImprovementBlotterItem({
  isVisible,
  isDropdownItem,
  onClick,
}: VisibleItem & IsDropdownItem & ClickableItem) {
  return (
    <NavigationItem
      isVisible={isVisible}
      targetRoute="/price-improvement-blotter"
      label="appHeader.navigation.activities.priceImprovement"
      dataE2eSuffix="improvement-blotter"
      category="Workspace"
      action="Price improvement blotter"
      isDropdownItem={isDropdownItem}
      onClick={onClick}
    />
  );
}

export const ConnectedPriceImprovementBlotterItem = connect((state: AppState) => ({
  isVisible: isPriceImprovementBlotterVisible(state),
}))(PriceImprovementBlotterItem);

export function SecondaryPostTradeItem({
  isVisible,
  isDropdownItem,
  onClick,
}: VisibleItem & IsDropdownItem & ClickableItem) {
  return (
    <NavigationItem
      isVisible={isVisible}
      isDropdownItem={isDropdownItem}
      targetRoute="/secondary-market-post-event-workspace"
      label="appHeader.navigation.activities.secondary.postTrade"
      dataE2eSuffix="secondary-post-event-workspace"
      category="Workspace"
      action="Secondary market post event workspace"
      onClick={onClick}
      title="appHeader.navigation.activities.secondary.postTrade.ariaLabel"
    />
  );
}

export const ConnectedSecondaryPostTradeItem = connect((state: AppState) => ({
  isVisible: isSecondaryPostEventVisible(state),
}))(SecondaryPostTradeItem);
